import { ArtBlocksChainId } from "contractConfig"
import {
  getArtBlocksGeneratorUrl,
  isArtBlocksChainId,
  normalizeContractAddress,
} from "utils/artBlocksUrls"

/** r4v3n Art Blocks Engine Flex (mainnet). Project 0 = Marfa: Middle of Somewhere. */
export const MOS_ENGINE_CONTRACT_ADDRESS = "0xd9b7ec74c06c558a59afde6a16e614950730f44d"
export const MOS_PROJECT_ID = 0
export const ART_BLOCKS_PROJECT_ID_MULTIPLIER = 1_000_000
export const MOS_LIVE_GENERATOR_PATH = "/generators/mos/index.html"

export const getArtBlocksProjectIdFromTokenId = (tokenId: string) => {
  const parsed = Number(tokenId)
  if (!Number.isFinite(parsed) || parsed < 0) return undefined
  return Math.floor(parsed / ART_BLOCKS_PROJECT_ID_MULTIPLIER)
}

/**
 * MOS live view is served from a site-hosted generator because the on-chain
 * project 0 script is permanently locked (pixelated overlay on high-DPI).
 * Project 1 on this contract is Marfa: Outtakes — a different generator.
 */
export const isMosLiveOverrideToken = (contractAddress: string, tokenId: string) =>
  normalizeContractAddress(contractAddress) === MOS_ENGINE_CONTRACT_ADDRESS &&
  getArtBlocksProjectIdFromTokenId(tokenId) === MOS_PROJECT_ID

export const getMosLiveGeneratorUrl = (tokenId: string, tokenHash?: string) => {
  const params = new URLSearchParams({ tokenId })
  if (tokenHash) params.set("hash", tokenHash)
  return `${MOS_LIVE_GENERATOR_PATH}?${params.toString()}`
}

interface LiveGeneratorUrlParams {
  contractAddress: string
  tokenId: string
  chainId?: number | string | null
  metadataGeneratorUrl?: string
  tokenHash?: string
}

export const getLiveGeneratorUrl = ({
  contractAddress,
  tokenId,
  chainId,
  metadataGeneratorUrl,
  tokenHash,
}: LiveGeneratorUrlParams) => {
  if (isMosLiveOverrideToken(contractAddress, tokenId)) {
    return getMosLiveGeneratorUrl(tokenId, tokenHash)
  }

  if (metadataGeneratorUrl) return metadataGeneratorUrl

  if (isArtBlocksChainId(chainId)) {
    return getArtBlocksGeneratorUrl({
      chainId: Number(chainId) as ArtBlocksChainId,
      contractAddress,
      tokenId,
    })
  }

  return undefined
}
